const topics = [
  { name: '暑期档票房大战', count: '2.8万讨论', hot: true },
  { name: '张艺谋争议新片', count: '1.9万讨论', hot: true },
  { name: '华语电影出海', count: '1.5万讨论', hot: false },
  { name: 'AI电影制作', count: '1.3万讨论', hot: true },
  { name: '明星恋情曝光', count: '1.2万讨论', hot: false },
  { name: '电影节前线', count: '9800讨论', hot: false },
  { name: '经典电影重映', count: '8600讨论', hot: false },
  { name: '流媒体大战', count: '7200讨论', hot: true },
  { name: '国产动画崛起', count: '6500讨论', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="bg-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 text-center mb-4">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">
            当下影视圈最受关注的话题标签与热度追踪
          </p>

          <div className="flex flex-wrap justify-center gap-3">
            {topics.map((topic, i) => (
              <a
                key={i}
                href="#hero"
                className="group flex items-center gap-2 px-5 py-3 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-200 cursor-pointer"
              >
                {topic.hot && (
                  <span className="flex-shrink-0 w-5 h-5 flex items-center justify-center">
                    <i className="ri-fire-line text-sm text-primary-500"></i>
                  </span>
                )}
                <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  # {topic.name}
                </span>
                <span className="text-xs text-foreground-400 ml-1">{topic.count}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}